export default "__VITE_ASSET__RCEXl1Vw__"